<template>
    <div class="follow">
        <!-- <transition name="van-slide-right"> -->
            <van-popup v-model="isShow" class="sharePopup" v-if="isShow">
                <div class="between">
                    <div class="followTitle">关注公众号</div>
                    <van-icon name="cross" @click="onClose" color="#999" size="19px" />
                </div>
                <!-- <div class="followTitle">关注公众号</div> -->
                <div style="width: 295px;">
                    <vue-qr :text="imageUrl" :size="250" :logoScale="0.2"> </vue-qr>
                </div>
                <div class="tips">长按识别二维码关注公众号</div>
            </van-popup>
        <!-- </transition> -->
        <div class="back-home" ref="moveBtn" @mousedown="down" @touchstart="down" @mousemove="move" @touchmove="move"
            @mouseup="end" @touchend="end" @touchcancel="end">
            <div class="followImage" @click="handleFollowClick">
                <img src="../../../assets/images/follow.png" alt="" />
            </div>
        </div>
    </div>
</template>
<script>
import {
    Icon,
    Popup,
} from "vant";
import vueQr from "vue-qr";
export default {
    data() {
        return {
            flags: false,
            position: {
                x: 0,
                y: 0
            },
            nx: "",
            ny: "",
            dx: "",
            dy: "",
            xPum: "",
            yPum: "",
            isShow: false,
            moveBtn: {},
            imageUrl: ''
        };
    },
    components: {
        [Icon.name]: Icon,
        [Popup.name]: Popup,
        vueQr
    },
    mounted() {
        this.imageUrl = `https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=${webconfig.WxUin}&scene=110#wechat_redirect`
        var beforeHeight = document.documentElement.clientHeight;
        // 初始
        localStorage.setItem('beforeScreenBefore', beforeHeight)
        this.moveBtn = this.$refs.moveBtn;
        // window.addEventListener('scroll', this.handleScroll, true)
        var u = navigator.userAgent;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端 
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端 
        if (isAndroid) {
            this.moveBtn.style.top = "80%";
        }
        if (isiOS) {
            // 屏幕高度- 底部栏高度 - 图片高度和间距
            this.moveBtn.style.top = document.documentElement.clientHeight - 50 - 100 + 'px';
            console.log(document.documentElement.clientHeight - 50 - 86, 43)
        }
        // 图片初始位置
        localStorage.setItem('moveBtnPosition', this.moveBtn.style.top)
        // 滚动条初始位置
        // localStorage.setItem("scrollmove", 0);
        this.moveBtn.style.left = "81vw";
    },
    destroyed() {
        // 销毁监听
        // window.removeEventListener("scroll", this.handleScroll, true);
    },
    methods: {
        handleScroll() {
            // 现在的屏幕高度
            var screenHeight = document.documentElement.clientHeight;
            localStorage.setItem('afterScreenHeight', screenHeight)
            // 获取图标现在的位置
            // var positionHeight = parseInt(this.moveBtn.style.top);
            // console.log('图片现在位置' + positionHeight, positionHeight - 10, '图片初始位置' + localStorage.getItem("moveBtnPosition"), "clientHeight468")

            // 如果屏幕没有变化
            // console.log(positionHeight + 'px' > localStorage.getItem("moveBtnPosition"), '屏幕现在高度' + localStorage.getItem("afterScreenHeight"), '屏幕初始高度' + localStorage.getItem("beforeScreenBefore"), 62)

            // 获取滚动条位置
            // var scrollTop = document.documentElement.scrollTop
            // console.log('滚动条位置' + scrollTop, '图片拖拽结束滚动条位置' + localStorage.getItem("scrollmove"))
            // if (localStorage.getItem("scrollmove") > 0 && localStorage.getItem("scrollmove") - 100 > scrollTop) {
            //     console.log('foce')
            // }
            //   现在屏幕高 > 初始值屏幕高 图片现在的位置top值大于 初始图片位置top值
            //  && localStorage.getItem("scrollmove") > 0 && localStorage.getItem("scrollmove") - 100 < scrollTop
            // if (localStorage.getItem("afterScreenHeight") > localStorage.getItem("beforeScreenBefore") && positionHeight - 10 + 'px' > localStorage.getItem("moveBtnPosition")) {

            //     console.log('触发事件', this.moveBtn.style.top)
            // } else {
            //     console.log('无事发生', this.moveBtn.style.top)
            //     this.moveBtn.style.transition = 'no'
            // }
            console.log(this.yPum > parseInt(localStorage.getItem("moveBtnPosition")), this.yPum, parseInt(localStorage.getItem("moveBtnPosition")), "777")
            // 现在  >  初始
            // if (localStorage.getItem("afterScreenHeight") !== localStorage.getItem("beforeScreenBefore")) {
            //     // top值 》 初始图片 现在图标位置》初始位置
            //     if (this.yPum > parseInt(localStorage.getItem("moveBtnPosition")) && positionHeight > localStorage.getItem("moveBtnPosition")) {
            //         this.moveBtn.style.top = localStorage.getItem("moveBtnPosition");
            //         console.log('触发事件', this.moveBtn.style.top)
            //     } else {
            //         console.log('无事发生', this.moveBtn.style.top)
            //         this.moveBtn.style.transition = 'no'
            //     }
            // }
        },
        // 关闭公众号二维码
        onClose() {
            this.isShow = false
        },
        // 显示公众号二维码
        handleFollowClick() {
            // window.location.href = `https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=${webconfig.WxUin}&scene=110#wechat_redirect`
            //    location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=Mzg5MDcwMjAxNw==&scene=110#wechat_redirect'
            this.isShow = true
        },
        // 实现移动端拖拽
        down(event) {
            this.flags = true;
            var touch;
            if (event.touches) {
                touch = event.touches[0];
            } else {
                touch = event;
            }
            // 点击的位置坐标位置
            this.position.x = touch.clientX;
            this.position.y = touch.clientY;
            this.dx = this.moveBtn.offsetLeft;
            this.dy = this.moveBtn.offsetTop;
        },
        move(event) {
            if (this.flags) {
                var touch;
                if (event.touches) {
                    touch = event.touches[0];
                } else {
                    touch = event;
                }
                // console.log(event.touches,touch.clientX,120)
                // 移动的距离
                this.nx = touch.clientX - this.position.x;
                this.ny = touch.clientY - this.position.y;
                this.xPum = this.dx + this.nx;
                this.yPum = this.dy + this.ny;
                this.yTabber = this.dy + this.ny;
                // 获取屏幕宽高
                var clientWidth = document.documentElement.clientWidth;
                var clientHeight = document.documentElement.clientHeight;
                var u = navigator.userAgent;
                var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端 
                var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端 
                var pageHeight
                // 屏幕高 - 底部栏高度
                if (isAndroid) {
                    pageHeight = clientHeight - 80;
                }
                if (isiOS) {
                    pageHeight = parseInt(localStorage.getItem("moveBtnPosition")) + 64;
                }
                if (
                    this.xPum > 0 &&
                    this.xPum < clientWidth - this.moveBtn.offsetWidth
                ) {
                    this.moveBtn.style.left = this.xPum + "px";
                }
                if (
                    this.yPum > 0 &&
                    this.yPum < pageHeight - this.moveBtn.offsetHeight
                ) {
                    this.moveBtn.style.top = this.yPum + "px";
                }

                //阻止页面的滑动默认事件
                document.addEventListener("touchmove", this.handler, {
                    passive: false
                });
            }
        },
        //鼠标释放时候的函数
        end() {
            this.flags = false;
            // var scrollmoveTop = document.documentElement.scrollTop
            // console.log('图片拖拽结束滚动条位置' + scrollmoveTop)
            // localStorage.setItem("scrollmove", scrollmoveTop);
            document.addEventListener("touchmove", this.handler, {
                passive: false
            });
        },
        handler(event) {
            if (this.flags) {
                event.preventDefault();
            } else {
                return true;
            }
        }
    }

};
</script>
<style lang="less" scoped>
.follow {
    height: 80%;
    position: fixed;
    z-index: 4;

    .between {
        padding: 16px 20px 0;
    }

    .followTitle {
        font-size: 16px;
        text-align: center;
        font-weight: 600;
        width: 100%;
        text-align: center;
        margin-left: 12px;
    }

    .tips {
        text-align: center;
        margin-bottom: 16px;
        color: #999999;
        font-size: 12px;
    }

    .sharePopup {
        border-radius: 8px;
    }

    .flexEnd {
        padding: 10px 10px 0 20px;
    }

    .back-home {
        position: relative;
        z-index: 99999;
        padding-bottom: 10px;
    }
}

.followImage {
    width: 17.06667vw;
    height: 17.06667vw;
}
</style>
  